import request from '@/utils/request'

// 支付厂家列表（payment_adapt）
export function listPaymentAdapt(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/payment.listPaymentAdapt',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取支付厂家列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 新增支付厂家
export function savePaymentAdapt(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/payment.savePaymentAdapt',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '保存支付厂家失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 修改支付厂家
export function updatePaymentAdapt(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/payment.updatePaymentAdapt',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '修改支付厂家失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除支付厂家（软删除）
export function deletePaymentAdapt(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/payment.deletePaymentAdapt',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '删除支付厂家失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 支付厂家参数项列表（payment_key）
export function listPaymentKey(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/payment.listPaymentKey',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取参数项列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 新增参数项
export function savePaymentKey(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/payment.savePaymentKey',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '保存参数项失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 修改参数项
export function updatePaymentKey(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/payment.updatePaymentKey',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '修改参数项失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除参数项（软删除）
export function deletePaymentKey(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/payment.deletePaymentKey',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '删除参数项失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
